import { createRouter, createWebHistory } from 'vue-router';
import Admin from '@/views/Admin.vue';

// Create a lazy-loaded component for the main application
const Home = () => import('@/views/Home.vue');

const routes: any[] = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
